import { createBrowserHistory } from 'history';
import _get from 'lodash/get';

const customHistory = createBrowserHistory();

const originalPush = customHistory.push;
const originalReplace = customHistory.replace;

// Check if embedded redirect value is new tab or not
export const isNotNewTabEmbeddedRedirect = () =>
  _get(window, 'xprops.redirect', '') !== 'new_tab';

customHistory.push = (path = '', state) => {
  if (isNotNewTabEmbeddedRedirect() || path.includes('/assessments/')) {
    originalPush.call(customHistory, path, state);
  } else {
    window.open(path, '_blank');
  }
};

customHistory.replace = (path, state) => {
  if (isNotNewTabEmbeddedRedirect()) {
    originalReplace.call(customHistory, path, state);
  }
};

export default customHistory;
